import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import style from '../css/Chat.module.css';
import { FaArrowAltCircleRight, FaChevronRight } from 'react-icons/fa';
import HeaderBarBack from '../components/HeaderBarBack';

const Chat = () => {
	const { guest_id } = useParams(); // Get guest_id from URL params
	const [messages, setMessages] = useState([]);
	const [message, setMessage] = useState('');
	const chatEndRef = useRef(null);

	// Fetch messages from API
	const fetchMessages = () => {
		fetch(
			`https://hometech-repairs.in/homeTech/get_messages.php?guest_id=${guest_id}`
		)
			.then((res) => res.json())
			.then((data) => {
				if (data.messages) {
					setMessages(data.messages);
					// Scroll down after fetching messages
					setTimeout(() => {
						chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
					}, 100);
				}
			})
			.catch((error) => console.error('Error fetching messages:', error));
	};

	// Fetch messages on load & every 2 seconds
	useEffect(() => {
		fetchMessages();
		const interval = setInterval(fetchMessages, 2000);
		return () => clearInterval(interval);
	}, []);

	// Scroll to bottom when messages update
	useEffect(() => {
		setTimeout(() => {
			chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
		}, 100);
	}, [messages]);

	const sendMessage = () => {
		if (!message.trim()) return;

		const newMessage = { guest_id, sender: 'admin', message };

		fetch('https://hometech-repairs.in/homeTech/save_message.php', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(newMessage),
		})
			.then((res) => res.json())
			.then(() => {
				setMessages((prevMessages) => [
					...prevMessages,
					{ sender: 'admin', message },
				]);
				setMessage('');
				// Scroll down after sending message
				setTimeout(() => {
					chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
				}, 100);
			})
			.catch((error) => console.error('Error sending message:', error));
	};

	return (
		<div className={style.chatContainer}>
			<HeaderBarBack title={guest_id} />
			<div className={style.chatMessages}>
				{messages.map((msg, index) => (
					<div
						key={index}
						className={`${style.message} ${
							msg.sender === 'admin' ? style.adminMessage : style.guestMessage
						}`}
					>
						<span>{msg.message}</span>
						<br />
						<span className={style.date}>
							{(() => {
								const date = new Date(msg.created_at);
								const day = String(date.getDate()).padStart(2, '0');
								const month = String(date.getMonth() + 1).padStart(2, '0');
								const year = date.getFullYear();
								return `${day}-${month}-${year}`;
							})()}
						</span>
					</div>
				))}
				{/* This empty div helps scroll to the bottom */}
				<div ref={chatEndRef}></div>
			</div>

			<div className={style.chatInputContainer}>
				<div className={style.chatInput}>
					<input
						type="text"
						value={message}
						onChange={(e) => setMessage(e.target.value)}
						placeholder="Type a message..."
						className={style.chatInput}
					/>
					<button onClick={sendMessage} className={style.sendButton}>
						<FaChevronRight size={20} color="white" />
					</button>
				</div>
			</div>
		</div>
	);
};

export default Chat;
